import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({

  select: {
    marginTop: '8px',
    marginBottom: '4px'
  },

  img: {
    width: '50px',
    height: '50px',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },

  switch: {
    flexDirection: 'unset',
    marginLeft: '-4px',
    userSelect: 'none'
  },

  namesLine: {
    textAlign: 'left',
    '& > *': {
      marginRight: '12px',
      width: 'calc(50% - 57px)'
    },
    '& > *:first-child': {
      width: '90px'
    },
    '& > *:last-child': {
      marginRight: '0'
    },
    [theme.breakpoints.down('550')]: {
      '& > *': {
        marginRight: '0',
        width: '100%'
      },
    },

  },


  newFile: {
    position: 'relative',
    width: '50px',
    height: '50px',
    borderRadius: '8px',
    overflow: 'hidden',
    transition: 'transform ease-in-out .2s',



    '&:hover': {
      transform: 'scale(1.1)',
    },

    '& > div': {
      position: 'absolute',
      pointerEvents: 'none',
      width: '100%',
      height: '100%',
      background: '#eee',

      '& button': {
        width: '100%',
        height: '100%',
      }
    },

    '& > input': {
      outline: 'none',
      cursor: 'pointer',
      width: '100%',
      height: '100%',
    }
  },

  fileHide: {
    display: 'none',
  },

  filePreview: {
    height: '50px',
    width: '50px',
    borderRadius: '7px',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'transform ease-in-out .2s',

    '&:hover': {
      transform: 'scale(1.1)'
    },

    '&:hover > div:first-child': {
      opacity: '1'
    },

  },

  clearBtn: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0',
    left: '0',
    opacity: '0',
    backgroundColor: '#eee',
    transition: 'opacity ease-in-out .15s',

    '& button': {
      width: '100%',
      height: '100%',
      borderRadius: '0!important'
    }
  },

  prefessionLine: {
    [theme.breakpoints.up('500')]: {
      display: 'flex',
      margin: '8px 0',
      gap: 8,
      '& > *': {
        width: '100%',
        margin: 0
      },
      '& .MuiInputBase-root': {
        height: '-webkit-fill-available'
      },
    },
  }

}))